/**
 * Error Alert Component
 */

import { X, AlertCircle } from 'lucide-react';

interface ErrorAlertProps {
  message: string;
  details?: string;
  onClose?: () => void;
}

export default function ErrorAlert({ message, details, onClose }: ErrorAlertProps) {
  return (
    <div className="rounded-2xl border border-red-200 bg-white text-red-900 shadow-lg shadow-red-500/10 dark:border-red-500/40 dark:bg-slate-900 dark:text-red-100 mb-6">
      <div className="flex items-start gap-3 px-4 sm:px-5 py-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-red-200 bg-red-50 text-red-600 dark:border-red-500/40 dark:bg-red-500/10 dark:text-red-200">
          <AlertCircle className="h-5 w-5" />
        </div>
        <div className="flex-1 space-y-1">
          <h3 className="text-sm font-semibold">{message}</h3>
          {details && <p className="text-sm text-red-700 dark:text-red-200">{details}</p>}
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-red-600 hover:text-red-700 dark:text-red-300 dark:hover:text-red-100 transition-colors"
            aria-label="Close alert"
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>
    </div>
  );
}
